// Getters
export const WHATS_NEW_SEARCH_RESULT = 'whats-new/WHATS_NEW_SEARCH_RESULT'
export const WHATS_NEW_HISTORY = 'whats-new/WHATS_NEW_HISTORY'
export const WHATS_NEW_MODAL = 'whats-new/WHATS_NEW_MODAL'

// Mutations
export const MUTATE_WHATS_NEW_SEARCH_RESULT = 'whats-new/MUTATE_WHATS_NEW_SEARCH_RESULT'
export const MUTATE_WHATS_NEW_HISTORY = 'whats-new/MUTATE_WHATS_NEW_HISTORY'
export const MUTATE_WHATS_NEW_MODAL = 'whats-new/MUTATE_WHATS_NEW_MODAL'

// Actions — administração
export const SEARCH_RELEASES = 'whats-new/SEARCH_RELEASES'
export const GET_RELEASE = 'whats-new/GET_RELEASE'
export const SAVE_RELEASE = 'whats-new/SAVE_RELEASE'
export const DELETE_RELEASE = 'whats-new/DELETE_RELEASE'
export const SET_RELEASE_STATUS = 'whats-new/SET_RELEASE_STATUS'
export const UPLOAD_VIDEO = 'whats-new/UPLOAD_VIDEO'

// Actions — consumo
export const CHECK_CURRENT_WHATS_NEW = 'whats-new/CHECK_CURRENT_WHATS_NEW'
export const OPEN_WHATS_NEW_MODAL = 'whats-new/OPEN_WHATS_NEW_MODAL'
export const CLOSE_WHATS_NEW_MODAL = 'whats-new/CLOSE_WHATS_NEW_MODAL'
export const GET_WHATS_NEW_HISTORY = 'whats-new/GET_WHATS_NEW_HISTORY'
export const TRACK_WHATS_NEW = 'whats-new/TRACK_WHATS_NEW'
